import { ProviderFormProvider } from '@pages/Fabric/common/ProviderFormContext';
import { UnifiedSnowflakeForm } from '@pages/Fabric/unifiedFabrics/snowflake/UnifiedSnowflakeForm';

import { SnowflakeReadOnlyView } from './SnowflakeReadOnlyView';

export const SnowflakeSetupForm = ({ isReadonly }: { isReadonly: boolean }) => {
  if (isReadonly) {
    return <SnowflakeReadOnlyView />;
  }

  return (
    <ProviderFormProvider isOrchestrationFabric={false}>
      <UnifiedSnowflakeForm />
    </ProviderFormProvider>
  );
};
